// Takes an array of objects with an id field and returns an object with the id as the key
export const byId = <T extends { id: number }>(items: T[]): Record<number, T> => {
  return items.reduce((acc, loc) => {
    acc[loc.id] = loc;
    return acc;
  }, {});
};
